import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageMother.module.scss";

function PageMother() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p12", "png");
  const item02 = getImgSet("item__02__p12", "png");
  const item03 = getImgSet("item__03__p12", "png");
  const item04 = getImgSet("item__04__p12", "png");
  const pointer = getImgSet("pointer__mother", "png", s.pointer);

  const back = getImgSet("back__p21", "png");
  const imgA = getImgSet("bear__02", "png", s.img__a);
  const imgB = getImgSet("img__p12", "png", s.img__b);
  const action = getImgSet("action__01__p12", "png");
  const quizBtn = getImgSet("button__quiz", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        {imgA}
        <Link to="/" className={s.back}>
          {back}
        </Link>
      </div>
      <div className={s.inner}>
        <Link to="b" className={cn(s.item, s.item__01)}>
          {item01}
        </Link>
        <Link to="c" className={cn(s.item, s.item__02)}>
          {item02}
        </Link>
        <Link to="e" className={cn(s.item, s.item__03)}>
          {item03}
        </Link>
        <Link to="g" className={cn(s.item, s.item__04)}>
          {item04}
        </Link>
      </div>
      <div className={s.aside_right}>
        {imgB}
        <Link to="a" className={s.action}>
          {action}
        </Link>
        <Link to="quiz" className={s.button__quiz}>
          {quizBtn}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageMother);
